<script setup>
import {computed, inject,  toRaw, } from "vue";
import {useI18n} from 'vue-i18n';
import {useSearchStore} from "../store/useSearchStore";

const store = useSearchStore();
const {t} = useI18n();
const $bus = inject('$bus');

const props = defineProps({
    facet: {
        type: Object,
        default: null,
        required: true,
    }
});

const updateSelectedFacets = (facets) => {
    $bus.emit('updateSelectedFacets', facets);
};

const setFacetActive = (id, facets) => {
    for (let x = 0; x < facets.value.length; x++) {
        if (facets.value[x].id === id) {
            facets.value[x].selected = true;
        }
    }
};

const handleChange = (event, facet) => {
    facet.selected = true;
    $bus.emit('updateSelectedFacets', facet, !event);
};

const translateFacetName = (name) => {
    if (name.startsWith('search.') || name.startsWith('search_')) {
        return t('search.' + name.replaceAll('.', '_'));
    } else {
        return t('name');

    }
};

const isSelected = computed(() => {
    if (store.selectedFacet === null && props.facet.id === 'ALL') {
        store.changeSelectedFacet(props.facet);
    }

    return toRaw(store.selectedFacet).id === toRaw(props.facet).id;
});

const changeSelectedFacet = (facet) => {
    if (store.searchQuery.length === 0) {
        $bus.emit('restartSearch');
    } else if (toRaw(store.selectedFacet).id !== facet.id) {
        store.changeSelectedFacet(facet);
        $bus.emit('updateSelectedFacets', facet, !event);
    }
};

</script>

<template>
    <a v-if="facet" :class="['facet-item',{'is-active' : isSelected}]"
       @click.prevent="changeSelectedFacet(toRaw(facet))">
        <span class="name">
            {{ translateFacetName('search.' + facet.id) }}
            <span class="quiet">({{ facet.count }})</span>
        </span>
    </a>
</template>
